module.exports = Mustache;


//////////////////
// WEBPACK FOOTER
// external "Mustache"
// module id = 543
// module chunks = 2